import type { TranslationCatalog } from "../TranslationManager";

export const nl: TranslationCatalog = {
  "labels.cardNumber": "Kaartnummer",
  "labels.expirationDate": "Vervaldatum",
  "labels.cvc": "Beveiligingscode",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / JJ",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Uw kaartnummer is ongeldig.",
  "errors.invalidExpiryDate": "De vervaldatum van uw kaart is ongeldig.",
  "errors.invalidCvc": "De beveiligingscode van uw kaart is ongeldig.",
  "errors.incompleteCardNumber": "Uw kaartnummer is onvolledig.",
  "errors.incompleteExpiryDate": "De vervaldatum van uw kaart is onvolledig.",
  "errors.incompleteCvc": "De beveiligingscode van uw kaart is onvolledig.",
  "errors.expiredCard": "Uw kaart is verlopen.",
  "aria.cardNumber": "Kaartnummer",
  "aria.expirationDate": "Vervaldatum",
  "aria.cvc": "Beveiligingscode",
  "aria.cardInput": "Kaartgegevens",
};
